<!-- ── HEADER BAR ──────────────────────────────────────────── -->
<div
  style="
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0;
    padding: 8px 14px;
    border-bottom: 1px solid #e8ecf3;
    background: #fafafa;
    border-radius: 10px 10px 0 0;
    font-family: 'Poppins', sans-serif;
  "
>
  <!-- UUID -->
  <div
    style="
      display: flex;
      align-items: center;
      padding: 4px 14px 4px 0;
      border-right: 1px solid #d8dde6;
    "
  >
    <span style="font-size: 11px; font-weight: 700; color: #555; margin-right: 4px;">UUID:</span>
    <span
      style="font-size: 12px; font-weight: 400; color: #151515"
      pTooltip="{{ group?.bulk_order_uuid }}"
      tooltipPosition="bottom"
    >
      {{ group?.bulk_order_uuid | slice: 0 : 20 }}...
    </span>
  </div>

  <!-- Client -->
  <div
    style="
      display: flex;
      align-items: center;
      padding: 4px 14px;
      border-right: 1px solid #d8dde6;
    "
  >
    <span style="font-size: 11px; font-weight: 700; color: #555; margin-right: 4px;">Client:</span>
    <span style="font-size: 12px; font-weight: 400; color: #151515">
      {{ group?.client_id }}
    </span>
  </div>

  <!-- Files -->
  <div
    style="
      display: flex;
      align-items: center;
      padding: 4px 14px;
      border-right: 1px solid #d8dde6;
    "
  >
    <span style="font-size: 11px; font-weight: 700; color: #555; margin-right: 4px;">Files:</span>
    <span style="font-size: 12px; font-weight: 400; color: #151515">
      {{ group?.total_files }}
    </span>
  </div>

  <!-- Status -->
  <div
    style="
      display: flex;
      align-items: center;
      padding: 4px 14px;
      border-right: 1px solid #d8dde6;
    "
  >
    <span style="font-size: 11px; font-weight: 700; color: #555; margin-right: 4px;">Status:</span>
    <app-status-badge [status]="group?.status"></app-status-badge>
  </div>

  <!-- Reviewer (only if present) -->
  <div
    *ngIf="group?.reviewer_email"
    style="
      display: flex;
      align-items: center;
      padding: 4px 14px;
      border-right: 1px solid #d8dde6;
    "
  >
    <span style="font-size: 11px; font-weight: 700; color: #555; margin-right: 4px;">Reviewer:</span>
    <span style="font-size: 12px; font-weight: 400; color: #151515">
      {{ group?.reviewer_email }}
    </span>
  </div>

  <!-- Actions pushed to right -->
  <div style="margin-left: auto; display: flex; align-items: center; gap: 10px; padding-left: 12px;">
    <p-button
        label="Download"
        (click)="getsendPdf()"
        styleClass="p-button-sm-outline"
        icon="pi pi-download"
        iconPos="left"
      ></p-button>
    <p-button
      label="Back"
      (click)="onBack()"
      styleClass="p-button-sm"
    ></p-button>
    <app-column-chooser [table]="fileTable"></app-column-chooser>
  </div>
</div>

<!-- ── FILES TABLE ─────────────────────────────────────────── -->
<div class="mt-1">
  <app-data-table
    #fileTable
    [columnChooser]="true"
    [columns]="fileColumns"
    [data]="fileDetails"
    [loading]="isLoading"
    [totalRecords]="totalRecords"
    [rows]="rowsPerPage"
    [paginator]="true"
    [lazy]="true"
    emptyMessage="No Files Found"
    (columnSort)="sortFiles($any($event))"
    (pageChange)="onPageChange($event)"
    (rowsChange)="onRowsPerPageChange($event)"
  >
    <ng-template appTableCell="s_no" let-row let-i="index">
      {{ pageNo + i + 1 }}
    </ng-template>

    <ng-template appTableCell="file_name" let-row>
      <span pTooltip="{{ row.file_name }}" tooltipPosition="top">
        {{
          row.file_name.length > 28
            ? (row.file_name | slice: 0 : 28) + '...'
            : row.file_name
        }}
      </span>
    </ng-template>

    <ng-template appTableCell="status" let-row>
      <app-status-badge [status]="row.status"></app-status-badge>
    </ng-template>

    <!-- Error Log -->
    <ng-template appTableCell="error_log" let-row>
      <span
        *ngIf="row.error_log; else noErrorLog"
        pTooltip="{{ row.error_log }}"
        tooltipPosition="top"
      >
        <i class="bx bx-error-circle error-icon"></i>
      </span>
      <ng-template #noErrorLog>—</ng-template>
    </ng-template>

    <!-- Action -->
    <ng-template appTableCell="action" let-row>
      <!-- Case 1: no order_id yet → clock icon, disabled -->
      <span
        *ngIf="!row.order_id"
        class="viewmore"
        style="cursor: not-allowed; opacity: 0.4;"
        pTooltip="Order not yet generated"
        tooltipPosition="top"
      >
        <i class="pi pi-clock"></i>
      </span>

      <!-- Case 2: order exists + AWAITING_APPROVAL → folder icon -->
      <a
        *ngIf="row.order_id && row.status === 'AWAITING_APPROVAL'"
        class="viewmore"
        (click)="openViewandOrderModal(row)"
        pTooltip="Approval Pending — Click to Review"
        tooltipPosition="top"
      >
        <i class="pi pi-folder-open" style="color: #e09007;"></i>
      </a>

      <!-- Case 3: order exists + any other status → eye icon -->
      <a
        *ngIf="row.order_id && row.status !== 'AWAITING_APPROVAL'"
        class="viewmore"
        (click)="openViewOrderModal(row)"
        pTooltip="View Order"
        tooltipPosition="top"
      >
        <i class="pi pi-eye"></i>
      </a>
    </ng-template>
  </app-data-table>
</div>

<!-- ── VIEW ORDER MODAL TEMPLATE ───────────────────────────── -->
<ng-template #viewOrderData let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title">View Order</h4>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="closeView()"
    ></button>
  </div>
  <div class="modal-body" style="background-color: #f3eeee; height: 100%;">
    <app-view-order
      [viewOrderId]="viewOrderId"
      [isBulkCatUploadOrder]="isBulkCatUploadOrder"
    ></app-view-order>
  </div>
</ng-template>